import { QueryResult, QueryConfig, QueryResponse, BaseQuery } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Pais } from "@/shared/types/pais";

export interface PaisQuery extends BaseQuery {
    nombre?: string,
    codigo?: string,
}

export async function getAllPaises(query?: PaisQuery): Promise<QueryResponse<Pais>> {
    await sleep(1000);
    const response = await api.get("paises", { params: removeNullOrEmptyKeys(query) }	);
    return response.data;
}

export function useGetAllPaisesQuery(query: PaisQuery = {}, queryConfig: QueryConfig<QueryResponse<Pais>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllPaises(query),
        queryKey: ["paises", query],
    })
}

export interface GetAllPaisesQueryProps {
    query: PaisQuery,
    queryConfig?: QueryConfig<QueryResponse<Pais>>,
    children: (queryResult: QueryResult<QueryResponse<Pais>>) => ReactNode
}

export function GetAllPaisesQuery({
    query,
    queryConfig,
    children
}: GetAllPaisesQueryProps) {
    const queryResult = useGetAllPaisesQuery(query, queryConfig);
    return children && children(queryResult);
}
    